export default {
  services: [],
  serviceTypes: []
};
